var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":require('@/assets/logo.png'),"min-height":"100px","max-height":"250px"}})}
var staticRenderFns = []

export { render, staticRenderFns }